var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C7 0.447715 6.55228 0 6 0H5C4.44772 0 4 0.447715 4 1V3C4 3.55229 3.55228 4 3 4H1C0.447715 4 0 4.44772 0 5V6C0 6.55228 0.447715 7 1 7H3C3.55228 7 4 7.44772 4 8V10C4 10.5523 4.44772 11 5 11H6C6.55228 11 7 10.5523 7 10V8C7 7.44771 7.44772 7 8 7H10C10.5523 7 11 6.55228 11 6V5C11 4.44772 10.5523 4 10 4H8C7.44772 4 7 3.55228 7 3V1Z",
    fill: "#ADA8C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c3445932ffefca13c38e0a7d97044314.svg";
export { ForwardRef as ReactComponent };